import { Dispatch, SetStateAction, useContext } from 'react'

import { ThemeContext, UserTheme } from '../contexts/theme_context'

export const useTheme = (): [
  theme: UserTheme,
  setTheme: Dispatch<SetStateAction<UserTheme>>,
] => {
  const [theme, setTheme] = useContext(ThemeContext)
  if (!setTheme) {
    throw `ThemeContext is not available`
  }

  return [theme, setTheme]
}
